import { render, staticRenderFns } from "./AppPhoneField.vue?vue&type=template&id=a2d154ac&"
import script from "./AppPhoneField.vue?vue&type=script&lang=js&"
export * from "./AppPhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports